export const PERIOD_TIMESPAN = parseInt(
  process.env.REACT_APP_PERIOD_TIMESPAN,
  10,
);
export const YEAR_THRESHOLD = 1349;
export const NEWEST_OBJECT_YEAR = 2005;
export const SEARCH_RESULT_SIZE = 250;



// WEBPACK FOOTER //
// ./src/config.js